/** @jsxImportSource @emotion/react */
import { Card, CardContent, Typography, useTheme, Box } from '@mui/material'
import { People } from '@mui/icons-material'
import { cardTitle, metricCard } from '../styles/Admin.styles'

interface TotalUsersCardProps {
  count: number
  title: string
}

export const AdminTotalUsersCard = ({ count, title }: TotalUsersCardProps) => {
  const theme = useTheme()

  return (
    <Card css={metricCard()}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2" css={cardTitle}>
            {title}
          </Typography>

          <People
            sx={{
              color: theme.palette.uintel.main,
              opacity: 1,
              fontSize: 28,
            }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} css={cardTitle}>
          {count ?? '-'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Total registered users for this client
        </Typography>
      </CardContent>
    </Card>
  )
}
